import * as THREE from "three";
import {GeneratorValues} from "../../../product-types";
import {curveSegments, grooveThickness, wallThickness} from "../../../../consts";
import {createShape} from "../../../../utils";

export const createGrooves = (radius: number, values: GeneratorValues) => {
    const count = Number(values.count);
    const grooveWidth = ((Math.PI * radius) / count);

    const shape = new THREE.Shape()
    shape.lineTo(0, 0)
    shape.lineTo(0, -grooveThickness)
    shape.lineTo(grooveWidth, -grooveThickness)
    shape.lineTo(grooveWidth, 0)
    shape.lineTo(2*grooveWidth, 0)
    const points = shape.getPoints()

    const outerShape = createShape(points, values.count as number, radius)

    const hole = new THREE.Path()
        .moveTo(0, 0)
        .absarc(0, 0, radius - wallThickness, 0, Math.PI * 2, false);
    outerShape.holes.push(hole);

    const extrudeSettings = {
        depth: values.height,
        bevelEnabled: false,
        curveSegments: curveSegments,
        steps: 32,
    }

    return new THREE.ExtrudeGeometry(outerShape, extrudeSettings)

    // let circleShape = new THREE.Shape();
    //
    // for (let i = 0; i < count; i++) {
    //     const start = grooveWidth * i;
    //     const mid = grooveWidth * i + grooveWidth / 2;
    //     const end = grooveWidth * (i + 1);
    //
    //     // Calculate beginning coordinates
    //     const internalStartX = internalRadius * Math.cos(start);
    //     const internalStartY = internalRadius * Math.sin(start);
    //
    //     // Calculate beginning coordinates
    //     const externalStartX = externalRadius * Math.cos(mid);
    //     const externalStartY = externalRadius * Math.sin(mid);
    //
    //     circleShape = circleShape
    //         .moveTo(internalStartX, internalStartY)
    //         .absarc(0, 0, internalRadius, start, mid, false)
    //         .lineTo(externalStartX, externalStartY)
    //         .absarc(0, 0, externalRadius, mid, end, false);
    // }
    //
    // const hole = new THREE.Path()
    //     .moveTo(0, 0)
    //     .absarc(0, 0, externalRadius - wallThickness, 0, Math.PI * 2, false);
    // circleShape.holes.push(hole);
    //
    // const extrudeSettings = {
    //     depth: values.height,
    //     curveSegments: curveSegments,
    //     steps: 10,
    // };
    //
    // return new THREE.ExtrudeGeometry(circleShape, extrudeSettings);
}